import { render, staticRenderFns } from "./OutdoorCard.vue?vue&type=template&id=889e3ed6"
import script from "./OutdoorCard.vue?vue&type=script&lang=js"
export * from "./OutdoorCard.vue?vue&type=script&lang=js"
import style0 from "./OutdoorCard.vue?vue&type=style&index=0&id=889e3ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports